<loader-overlay *ngIf="!chatId"> </loader-overlay>
<drag-and-drop [disabled]="!allowFileUpload() || !initCompleted()" (fileAdded)="onUploadFiles($event?.files)">
  <div class="chat-container" [class.external-chat]="assistantData()?.knowledgeType === 'External'">
    @if (isEmptyState()) {
      <chat-empty-state
        [assistantData]="assistantData()"
        [showResumeLastThread]="showResumeLastThread()"
        (handleStartConversation)="startChatSessionWithQuery($event)"
        (onResumeLastThread)="resumeLastThread()"
      ></chat-empty-state>
    }
    <ng-scrollbar class="chat-scrollbar-wrapper" *ngIf="chatHistoryData()?.length || draftQuestion()" visibility="hover">
      <div class="chat-items">
        <ng-container *ngFor="let entry of chatHistoryData() || []; let i = index; let last = last; let first = first; trackBy: trackById">
          <chat-question-message [message]="entry.userMessage"></chat-question-message>
          <chat-answer-message
            *ngIf="entry.assistantMessage"
            [messageInprogress]="messageInprogress"
            [questionQuery]="entry.userMessage?.content"
            [assistantData]="assistantData()"
            [message]="entry.assistantMessage"
            [searchId]="entry.assistantMessage?.searchId"
            [chatId]="entry.chatId"
            [viewMode]="last && currentMessageState === 'interactiveTyping' ? 'interactive' : 'static'"
            [sessionId]="sessionId"
            [isLoadingAnswer]="isLoadingAnswer || isLoadingNextAnswerPart"
            [isFeedbackOpen]="feedback?.index === i"
            [showSearchId]="showSearchId()"
            (answerTypedFinished)="onAnswerTypedFinished()"
            (feedbackShow)="showFeedback($event, i)"
          ></chat-answer-message>
          <div #answerFeedback *ngIf="feedback?.index === i" class="answer-feedback-extension">
            <answer-feedback
              [model]="feedback"
              [query]="entry.userMessage?.content"
              [source]="'chat'"
              (closeFeedback)="closeFeedback()"
            ></answer-feedback>
          </div>
        </ng-container>
        <ng-container *ngIf="draftQuestion() && isLoadingAnswer">
          <chat-question-message [message]="draftQuestion()"></chat-question-message>
        </ng-container>
        <ng-container *ngIf="isLoadingAnswer || isLoadingNextAnswerPart">
          <result-answer-ghost
            class="loading-msg"
            [progressId]="progressId()"
            [avatarTemplate]="assistantIconTemp"
            [customStyles]="{ icon1FontSize: '15px', icon2FontSize: '9px' }"
          ></result-answer-ghost>
        </ng-container>
      </div>
    </ng-scrollbar>

    <div class="footer" #footer>
      @if (isExtension) {
        <div class="footer-container">
          <chat-assistant-dropdown
            filterPlaceholder="Search Assistant"
            [selectedAssistant]="assistantData()"
            [dropdownView]="'extension'"
            [tooltip]="'Select Chat'"
            (onSelectedAssistant)="onChangedAssistant($event)"
          ></chat-assistant-dropdown>
          <div class="footer-buttons">
            @if (assistantData()?.state === 'enabled' && assistantData()?.canAccess) {
              <u-button
                [versionNumber]="2"
                typeElement="secondary"
                fontIcon="cog2"
                [sizeElement]="'extra-large'"
                (onClick)="openNewAssistantPage()"
                [pTooltip]="'Preferences'"
                tooltipPosition="left"
                tooltipStyleClass="u-tooltip"
              ></u-button>
            }
            @if (!isEmptyState()) {
              <u-button
                [versionNumber]="2"
                typeElement="secondary"
                fontIcon="new-chat"
                [sizeElement]="'extra-large'"
                (onClick)="openNewChat()"
                [pTooltip]="'New chat'"
                tooltipPosition="bottom"
                tooltipStyleClass="u-tooltip"
              ></u-button>
            }
          </div>
        </div>
      }
      @if (isReadOnlyChat()) {
        <ng-container [ngTemplateOutlet]="errorSection"></ng-container>
      } @else {
        @if (initStatus() === 'error') {
          <ng-container [ngTemplateOutlet]="errorSection"></ng-container>
        }
        <chat-textarea
          [chatId]="chatId"
          [messageInprogress]="messageInprogress"
          [assistantData]="assistantData()"
          [allowFileUpload]="allowFileUpload()"
          [totalCountsFiles]="totalCountsFiles()"
          [initCompleted]="initCompleted()"
          (queryChange)="onQueryChange($event)"
          (sendQuery)="sendHandler()"
          (cancelQuery)="cancelQuery()"
          (uploadFiles)="onUploadFiles($event)"
          (removeFile)="onRemoveFile($event)"
          (onEscape)="closeFeedback()"
        ></chat-textarea>
        <disclaimer-alert *ngIf="enableDisclaimer && !isExtension" class="diclimer results"></disclaimer-alert>
      }

      <banner-alert></banner-alert>
    </div>
  </div>
</drag-and-drop>

<ng-template #assistantIconTemp>
  <div class="assistant-icon-header">
    <assistant-icon
      [model]="assistantData()"
      [spriteEmojiSize]="isExtension ? 16 : 24"
      [displayBorder]="false"
      [iconStyles]="
        isExtension ? { 'font-size': '12px', height: '16px', width: '16px' } : { 'font-size': '19px', height: '24px', width: '24px' }
      "
    ></assistant-icon>
    @if (isExtension) {
      <div class="assistant-name">{{ assistantData().name }}</div>
    }
  </div>
</ng-template>

<ng-template #errorSection>
  <div class="assistant-warning">
    <div [class]="isInitFailed ? 'danger-icon' : 'warning-icon'"><div class="icon">!</div></div>
    <div class="assistant-warning-text">
      <div>{{ isInitFailed ? INIT_FAILED_TEXT : ASSISTANT_DELETED_TEXT + (isExtension ? ASSISTANT_DELETED_TEXT_EXTENSION : '') }}</div>
      @if (isInitFailed || !isExtension) {
        <u-button
          (onClick)="isInitFailed ? init() : deleteSession()"
          [versionNumber]="2"
          [label]="isInitFailed ? 'Reload' : 'Delete thread'"
          [elementSize]="'extra-small'"
          [typeElement]="'danger'"
          [styleType]="'text'"
        ></u-button>
      }
    </div>
  </div>
</ng-template>
